import React from "react";

export default React.createContext({
    lazyParams: {},
    setLazyParams: () => { },
    rechercheApi: () => { },
    totalCandidatsRecords: 0,
    tokenResetFilters : null
});